import { Component, OnInit, ViewChild } from '@angular/core';
import { Task } from '../../../api/models/task';
import { ProjectSummary, PaginatedOrderHistory, orderStatusReportRequest, OrderScheduleLines } from '../../../api/models/project-summary';
import { Project } from '../../../api/models/project-model';
import { OrderHistory } from './../../../api/models/project-summary';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Market } from '../../../api/models/market-model';
import { Organization } from '../../../api/models/organization';
import { RoleRequest } from '../../../api/models/role-assignment-map';
import { User } from '../../../api/models/user-model';
import { AuthService } from '../../../api/services/auth.service';
import { MarketService } from '../../../api/services/market.service';
import { UserService } from '../../../api/services/user.service';
import { ReportService } from '../../../api/services/report.services';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { PaginatedRequest } from '../../../api/models/paginated-request';
import { ToastrService } from 'ngx-toastr';
import { AnalyticsService } from '../../../api/services/analytics.service';

@Component({
    selector: 'app-orderstatus-report',
    templateUrl: './orderstatus-report.component.html',
    styleUrls: ['./orderstatus-report.component.scss']
})
export class OrderStatusReportComponent implements OnInit {

    
    roleRequest: RoleRequest;
    isTesscoAdmin: boolean;
    organizations: Organization[] = [];
    allMarkets: Market[] = [];
    marketsFiltered: Market[] = [];
    selectedOrgId = '';
    accountNumber: string;

    sortDirection: string;
    poEntryDateSortDirection = '';
    poNumberSortDirection = '';
    orderNumberSortDirection = '';
    statusSortDirection = '';
    requestedDeliveryDate = '';
    projectNameSortDirection = '';
    page = 1;
    pageSize = 15;

    tasks: Task[];
    project: Project;
    target = 'all';
    projectSummary: ProjectSummary = new ProjectSummary();
    loading = true;
    showPOSummarySearchOption = false;
    tempOrders: OrderHistory[];
    showNoOrdersMessage = false;
    noOrdersMessage = ['There are no orders to display for this market.'];
    @ViewChild('accordion') accordion: NgbAccordion;
    isExpandAll: boolean = false;

    totalRecords = 0;
    sorting: string = 'so_number';
    paginatedRequest: PaginatedRequest;
    orderStatusReport: PaginatedOrderHistory;
    orderStautsReportRequest: orderStatusReportRequest;
    orderStatusExportRequest: orderStatusReportRequest;
    selectedMarket : Market;
    selectedAccountNumber:string;
    selectedLocationCode:string;
    selectedMarketName:string;
    blob: any;
    excelLoading: boolean = false;
    excelBtnDisabled: boolean = false;
    showOrderSearchOption: boolean = false;
    reportFilterKey:string;
    reportFilterKeyValue:string;
    reportFilterSearchValue:string;
    placeholder : string = 'Enter search value';
    searchTextValue:string;
    reportFilterOptions = [
        {"reportFilterKey": "PONumber"}, 
        {"reportFilterKey": "OrderNumber"},
        {"reportFilterKey": "ProjectName"}
    ];
    errorMessage: string[] = [];

    constructor(
        private authService: AuthService,
        private userService: UserService,
        private marketService: MarketService,
        private toastr: ToastrService,
        private reportService: ReportService,
        private analyticsService: AnalyticsService
    ) { }

    ngOnInit() {
        this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
        this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
            this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
        });
        forkJoin(this.userService.findUserById(this.authService.getUserId()), this.userService.getOrganizations())
            .subscribe((data: [User, Organization[]]) => {
                let currentOrgId = data[0]['Organization ID'];
                this.selectedOrgId = currentOrgId;
                this.organizations = data[1];
                this.marketService.getMarketsByOrgId(currentOrgId).subscribe(markets => {
                    this.allMarkets = markets;
                    this.allMarkets = this.allMarkets.filter(mkt => this.userService.isMarketPermittedForCurrentUser(mkt.id));
                    this.marketsFiltered = this.allMarkets;
                    if(this.marketsFiltered.length>0){
                        this.marketsFiltered = this.marketsFiltered.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                        this.selectedMarket = this.marketsFiltered[0];
                        this.selectedAccountNumber = this.selectedMarket.accountNumber;
                        this.selectedLocationCode = this.selectedMarket.locationCode;
                        this.selectedMarketName = this.selectedMarket.name;
                        this.loadPage(1,this.selectedAccountNumber,this.selectedLocationCode);
                    }else{
                        this.noOrdersMessage = ['There are no markets for this organization.'];
                        this.loading = false;
                        this.totalRecords = 0;
                        this.projectSummary.orders = [];
                        this.marketsFiltered = [];
                        this.showNoOrdersMessage = true;
                    }

                });
            });
        this.showNoOrdersMessage = false;
    }

    loadPage(page,customerNumber:string,locationCode:string,reportFilterKey?:string,reportFilterValue?:string){
        this.loading = true;
        this.paginatedRequest = new PaginatedRequest(page+1, this.pageSize, this.sorting);
        this.reportService.getOrderStatusReport(new orderStatusReportRequest(customerNumber,locationCode),this.paginatedRequest,reportFilterKey,reportFilterValue).subscribe(items => {
            this.loading = false;
            this.orderStatusReport = items;
            this.collapseAllItems();
            if (this.orderStatusReport.totalRecords && this.orderStatusReport.totalRecords > 0) {
                this.totalRecords = this.orderStatusReport.totalRecords;
                this.projectSummary.orders = this.orderStatusReport.records;
                this.showOrderSearchOption = true;
                if (!this.projectSummary || !this.projectSummary.orders || this.projectSummary.orders.length < 1) {
                    this.showNoOrdersMessage = true;
                    this.showOrderSearchOption = false;
                    this.noOrdersMessage = ['There are no orders to display for this market.'];
                }
            } else {
                this.totalRecords = 0;
                this.projectSummary.orders = [];
                this.showNoOrdersMessage = true;
                this.noOrdersMessage = ['There are no orders to display for this market.'];
            }
            this.sendDataToAnalytics();
        }, error => {
            this.errorMessage.push(error.error.message);
            this.showOrderSearchOption = false;
            this.projectSummary.orders = [];
            this.totalRecords = 0;
            this.loading = false;
        });
    }

    private sendDataToAnalytics() {
        this.analyticsService.trackReportSearch('order_status_report');
    }

    changeOrg(organizationId: string) {
        this.selectedOrgId = organizationId;
        this.loading = true;
        this.errorMessage = [];
        this.marketService.getMarketsByOrgId(this.selectedOrgId).subscribe(markets => {
            if(markets.length>0){
                this.reportFilterKey='';
                this.reportFilterKeyValue='';
                this.reportFilterSearchValue='';
                this.searchTextValue = '';
                this.showNoOrdersMessage = false;
                this.showOrderSearchOption = false;
                this.marketsFiltered = markets;
                this.marketsFiltered = this.marketsFiltered.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
                this.page = 1;
                this.selectedMarket = this.marketsFiltered[0];
                this.selectedAccountNumber = this.marketsFiltered[0].accountNumber;
                this.selectedLocationCode = this.marketsFiltered[0].locationCode;
                this.selectedMarketName = this.marketsFiltered[0].name;
                this.loadPage(1,this.selectedAccountNumber,this.selectedLocationCode);
            }else{
                this.noOrdersMessage = ['There are no markets for this organization.'];
                this.loading = false;
                this.totalRecords = 0;
                this.projectSummary.orders = [];
                this.marketsFiltered = [];
                this.showNoOrdersMessage = true;
                this.showOrderSearchOption = false;
            }
        });
    }

    changeMarket(index){
        this.errorMessage = [];
        this.selectedMarket = this.marketsFiltered[index];
        this.loading = true;
        this.reportFilterKey='';
        this.reportFilterKeyValue='';
        this.reportFilterSearchValue='';
        this.searchTextValue = '';
        this.totalRecords = 0;
        this.page = 1;
        this.showNoOrdersMessage = false;
        this.showOrderSearchOption = false;
        this.selectedAccountNumber = this.selectedMarket.accountNumber;
        this.selectedLocationCode = this.selectedMarket.locationCode;
        this.selectedMarketName = this.selectedMarket.name;
        this.loadPage(1,this.selectedAccountNumber,this.selectedLocationCode);
    }

    

    isOpened(index: number) {
        const id = `ngb-panel-${index}`;
        return this.accordion.activeIds.includes(id);
    }

    expandCollapseAll() {
        if (this.isExpandAll) {
            this.isExpandAll = false;
            this.accordion.activeIds = [];
        } else {
            this.isExpandAll = true;
            if (this.projectSummary.orders && this.projectSummary.orders.length) {
                let activeIds: string[] = [];
                this.projectSummary.orders.forEach((order, index) => {
                    activeIds.push(`ngb-panel-${index + 2}`);
                });
                this.accordion.activeIds = activeIds;
            }
        }
    }

    sortProjectName() {
        if (this.projectNameSortDirection === '') {
            this.projectNameSortDirection = 'asc';
        } else if (this.projectNameSortDirection === 'asc') {
            this.projectNameSortDirection = 'desc';
        } else {
            this.projectNameSortDirection = '';
        }
        this.sortDirection = this.projectNameSortDirection;
        this.poNumberSortDirection = '';
        this.orderNumberSortDirection = '';
        this.statusSortDirection = '';
        this.requestedDeliveryDate = '';
    }

    sortPOEntryDate() {
        if (this.poEntryDateSortDirection === '') {
            this.poEntryDateSortDirection = 'asc';
        } else if (this.poEntryDateSortDirection === 'asc') {
            this.poEntryDateSortDirection = 'desc';
        } else {
            this.poEntryDateSortDirection = '';
        }
        this.sortDirection = this.poEntryDateSortDirection;
        this.poNumberSortDirection = '';
        this.orderNumberSortDirection = '';
        this.statusSortDirection = '';
        this.requestedDeliveryDate = '';
        this.projectNameSortDirection = ''
    }

    sortPONumber() {
        if (this.poNumberSortDirection === '') {
            this.poNumberSortDirection = 'asc';
        } else if (this.poNumberSortDirection === 'asc') {
            this.poNumberSortDirection = 'desc';
        } else {
            this.poNumberSortDirection = '';
        }
        this.sortDirection = this.poNumberSortDirection;
        this.poEntryDateSortDirection = '';
        this.orderNumberSortDirection = '';
        this.statusSortDirection = '';
        this.requestedDeliveryDate = '';
        this.projectNameSortDirection = ''
    }

    sortOrderNumber() {
        if (this.orderNumberSortDirection === '') {
            this.orderNumberSortDirection = 'desc';
        } else if (this.orderNumberSortDirection === 'desc') {
            this.orderNumberSortDirection = 'asc';
        } else {
            this.orderNumberSortDirection = '';
        }
        this.sortDirection = this.orderNumberSortDirection;
        this.poEntryDateSortDirection = '';
        this.poNumberSortDirection = '';
        this.statusSortDirection = '';
        this.requestedDeliveryDate = '';
        this.projectNameSortDirection = ''
    }

    sortStatus() {
        if (this.statusSortDirection === '') {
            this.statusSortDirection = 'asc';
        } else if (this.statusSortDirection === 'asc') {
            this.statusSortDirection = 'desc';
        } else {
            this.statusSortDirection = '';
        }
        this.sortDirection = this.statusSortDirection;
        this.poEntryDateSortDirection = '';
        this.poNumberSortDirection = '';
        this.orderNumberSortDirection = '';
        this.requestedDeliveryDate = '';
        this.projectNameSortDirection = ''
    }

    sortReqDeliveryDate() {
        if (this.requestedDeliveryDate === '') {
            this.requestedDeliveryDate = 'asc';
        } else if (this.requestedDeliveryDate === 'asc') {
            this.requestedDeliveryDate = 'desc';
        } else {
            this.requestedDeliveryDate = '';
        }
        this.sortDirection = this.requestedDeliveryDate;
        this.poEntryDateSortDirection = '';
        this.poNumberSortDirection = '';
        this.orderNumberSortDirection = '';
        this.statusSortDirection = '';
        this.projectNameSortDirection = ''
    }

    sortColumns(n: number) {
        if (n == 1) {
            this.sortProjectName();
        }else if (n == 2) {
            this.sortPOEntryDate();
        } else if (n == 3) {
            this.sortPONumber();
        } else if (n == 4) {
            this.sortOrderNumber();
        } else if (n == 5) {
            this.sortStatus();
        } else if (n == 6) {
            this.sortReqDeliveryDate();
        }
    }



    sortTable(n: number) {
        this.sortColumns(n);
        var tempSortDir = this.sortDirection;
        if (this.sortDirection === '') {
            this.projectSummary.orders = JSON.parse(JSON.stringify(this.tempOrders));
        }
        if (this.projectSummary.orders && this.projectSummary.orders.length) {
            var orderArray = this.projectSummary.orders
            orderArray.sort(function (a, b) {
                let keyA, keyB;
                if (n == 1) {
                    keyA = a.projectName;
                    keyB = b.projectName;
                }else if (n == 2) {
                    keyA = new Date(a.customerPODate);
                    keyB = new Date(b.customerPODate);
                } else if (n == 3) {
                    keyA = a.poNumber;
                    keyB = b.poNumber;
                } else if (n == 4) {
                    keyA = Number(a.salesOrderNumber);
                    keyB = Number(b.salesOrderNumber);
                } else if (n == 5) {
                    keyA = a.status.toLowerCase();
                    keyB = b.status.toLowerCase();
                } else if (n == 6) {
                    keyA = new Date(a.reqDeliveryDate);
                    keyB = new Date(b.reqDeliveryDate);
                }
                if (tempSortDir == 'asc') {
                    if (keyA < keyB) return -1;
                    if (keyA > keyB) return 1;
                    return 0;
                } else if (tempSortDir == 'desc') {
                    if (keyA < keyB) return 1;
                    if (keyA > keyB) return -1;
                    return 0;
                }
            });
            this.projectSummary.orders = orderArray;
        }
    }

    downloadXls() {
        this.excelLoading = true;
        this.excelBtnDisabled = true;
        this.orderStatusExportRequest = new orderStatusReportRequest(this.selectedAccountNumber,this.selectedLocationCode);
        this.orderStatusExportRequest.marketName = this.selectedMarketName;
        this.reportService.downloadOrderStatusReport(this.orderStatusExportRequest).subscribe((resp) => {
          const fileName = resp.headers.get('filename') ? resp.headers.get('filename') : 'Order_Status_'+this.selectedMarketName +'_' + new Date();
          const data = resp.body;
          this.blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          });
          var downloadUrl = window.URL.createObjectURL(data);
          var link = document.createElement('a');
          link.href = downloadUrl;
          link.download = fileName + '.xlsx';
          link.click();
          this.excelLoading = false;
          this.excelBtnDisabled = false;
        }, error => {
          this.onError("Error downloading the file!!!");
          this.excelLoading = false;
          this.excelBtnDisabled = false;
        });
      }

    private onError(msg: string) {
    this.toastr.error(msg, 'Error!', {
        timeOut: 3000,
        positionClass: 'toast-bottom-right'
    });
    }

    selectSearchOption(event: any) {
        this.reportFilterKey = event.target.value;
        switch (this.reportFilterKey) {
          case 'PONumber': this.placeholder = 'Enter PO Number';
          break;
          case 'OrderNumber': this.placeholder = 'Enter Order Number';
          break;
          case 'ProjectName': this.placeholder = 'Enter Project Name';
          break;
          default: this.placeholder = 'Enter Search Value';
          break;
        }
        this.reportFilterSearchValue = '';
        this.searchTextValue = '';
    }

    onEnteringSearchValue(value) {
        this.reportFilterSearchValue = value;
    }

    filterOrderStatusReport() {
        this.showNoOrdersMessage = false;
        this.page =1;
        if(this.reportFilterKey == 'PONumber'){
            this.reportFilterKeyValue = "poNumber";
            this.loadPage(this.page,this.selectedAccountNumber,this.selectedLocationCode,this.reportFilterKeyValue,this.reportFilterSearchValue);
        }else if(this.reportFilterKey == 'OrderNumber'){
            this.reportFilterKeyValue = "orderNumber";
            this.loadPage(this.page,this.selectedAccountNumber,this.selectedLocationCode,this.reportFilterKeyValue,this.reportFilterSearchValue);
        }else if(this.reportFilterKey == 'ProjectName'){
            this.reportFilterKeyValue = "projectName";
            this.loadPage(this.page,this.selectedAccountNumber,this.selectedLocationCode,this.reportFilterKeyValue,this.reportFilterSearchValue);
        }
    }

    dismissErrorMessage() {
        this.errorMessage = [];
    }

    shouldApplyBorder(scheduleLine: OrderScheduleLines, length: number): boolean {
        return length > 0 &&
            (scheduleLine.expectedShipDate === 'Pending MFG Date'
                || scheduleLine.expectedShipDate === 'Pending Confirmation'
                || scheduleLine.expectedShipDate.includes("Shipped -")
                || scheduleLine.expectedShipDate.includes("Est. Avail.-"));
    }

    collapseAllItems() {
        this.isExpandAll = false;
        this.accordion.activeIds = [];
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/dashboard-reports/orderstatus-report/orderstatus-report.component.ts